export const TAP_PORTAL_ONLY_MESSAGE =
  "TAP accounts can only sign in from TAP login.";

export const TAP_ACCOUNT_REQUIRED_MESSAGE =
  "Only TAP accounts can sign in from TAP login.";

const readNestedRole = (source) => {
  if (!source || typeof source !== "object" || Array.isArray(source)) return "";
  const candidates = [
    source.role,
    source.userRole,
    source.user_role,
    source.accountRole,
    source.account_role,
    source.userType,
    source.user_type,
    source.type,
    source.user?.role,
    source.user?.userRole,
    source.admin?.role,
    source.adminDetails?.role,
    source.admin_details?.role,
  ];
  const raw = candidates.find((value) => value != null && String(value).trim() !== "");
  return String(raw || "").trim().toLowerCase();
};

export const extractLoginRole = (data) => {
  const items = data?.items;
  const fromAdminDetails = readNestedRole(items?.adminDetails) || readNestedRole(items?.admin_details);
  if (fromAdminDetails) return fromAdminDetails;
  const fromItems = readNestedRole(items);
  if (fromItems) return fromItems;
  return readNestedRole(data);
};

export const isTapRole = (role) => {
  const value = String(role || "").toLowerCase().replace(/[\s_-]/g, "");
  return value === "tap" || value === "tapuser" || value === "tapoperator";
};

export const assertAdminPortalAccess = (role) => {
  if (isTapRole(role)) {
    throw new Error(TAP_PORTAL_ONLY_MESSAGE);
  }
};

export const assertPartnerPortalAccess = (role) => {
  if (isTapRole(role)) {
    throw new Error(TAP_PORTAL_ONLY_MESSAGE);
  }
};

export const assertTapPortalAccess = (role) => {
  if (!isTapRole(role)) {
    throw new Error(TAP_ACCOUNT_REQUIRED_MESSAGE);
  }
};
